import { Box, Typography } from "@material-ui/core"

export function Title({
  title,
  scenario,
}: {
  title?: string
  scenario?: string
}) {
  return (
    <Box display="flex" style={{ gap: 4 }}>
      <Typography
        style={{
          fontSize: 12,
          fontWeight: "bold",
          lineHeight: 1.2,
          color: "white",
          marginLeft: "4px",
        }}
      >
        {title}
      </Typography>

      <Typography style={{ fontSize: 12, color: "white", lineHeight: 1.2 }}>
        {scenario}
      </Typography>
    </Box>
  )
}
